import React, { ReactNode } from 'react'
import { styled } from '@mui/system'
import ModalUnstyled from '@mui/base/ModalUnstyled'
import { Stack } from '@mui/material'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'

const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1500;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  &.MuiModal-hidden {
    visibility: hidden;
  }
`

const Backdrop = styled('div')`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
`

const style = {
  maxHeight: '90vh',
  overflowY: 'scroll',
  bgcolor: 'background.paper',
  border: '0',
  px: 3,
  py: 3,
  outline: 'none',
  borderRadius: '8px',
}

export const ModalButtonsContainerStack = styled(Stack)`
  flex-direction: row;
  justify-content: flex-end;
  column-gap: 16px;
  margin-top: 32px;
  align-items: center;
`

export default function JelledModal({
  isOpen,
  onClose,
  width,
  children,
  keepMounted,
  modalStyle,
}: {
  isOpen: boolean
  onClose?: () => void
  width: number | string
  children?: ReactNode
  keepMounted?: boolean
  modalStyle?: React.CSSProperties
}) {
  const isMobile = useCheckMobileScreen()

  const onModalClose = () => {
    onClose?.()
  }

  return (
    <StyledModal
      className="JelledModal"
      open={isOpen}
      slots={{ backdrop: Backdrop }}
      onClose={onModalClose}
      keepMounted={keepMounted}>
      <Stack position="relative" sx={{ ...style, ...modalStyle, maxHeight: isMobile ? '75vh' : '90vh', width: width }}>
        {children}
      </Stack>
    </StyledModal>
  )
}

JelledModal.defaultProps = {
  isOpen: true,
  width: 960,
}
